{
  "title": "Tongues",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level divination",
  "level": 3,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, M (a small clay model of a ziggurat)",
  "duration": "1 hour",
  "description": [
    "This spell grants the creature you touch the ability to understand any spoken language it hears. Moreover, when the target speaks, any creature that knows at least one language and can hear the target understands what it says."
  ],
  "spellLists": ["bard", "cleric", "sorcerer", "warlock", "wizard"]
}
